import { useTranslation } from "react-i18next";
import CustomModal from "../../packages/CustomModal";
import { STATUS_API_ERROR_KEYS } from "../../constants/global.constants";

const DEFAULT_DIALOG_TYPE = STATUS_API_ERROR_KEYS.NO_STABLE_POINTS;

const DIALOG_CONFIG = {
  [STATUS_API_ERROR_KEYS.NO_PREDICTED_CIPS]: {
    headerKey: "statusApiErrors.noPredictedCipsTitle",
    introKey: (isLifetime) =>
      isLifetime
        ? "statusApiErrors.noPredictedCipsLifetimeIntro"
        : "statusApiErrors.noPredictedCipsCleaningIntro",
    listItems: [
      { key: "statusApiErrors.noPredictedCipsEnsureHistory" },
      {
        key: "statusApiErrors.noPredictedCipsAlterSettings",
        subListClass: "marginTop10 predicted-cips-sub-list",
        subItems: [
          "statusApiErrors.noPredictedCipsIncreaseFouling",
          "statusApiErrors.noPredictedCipsDecreasePermeate",
          "statusApiErrors.noPredictedCipsDecreasePressure",
          "statusApiErrors.noPredictedCipsDecreaseSalt",
        ],
      },
    ],
    footerKey: null,
  },
  [STATUS_API_ERROR_KEYS.NO_STABLE_POINTS]: {
    headerKey: "statusApiErrors.noStablePointsTitle",
    introKey: () => "statusApiErrors.noStablePointsIntro",
    listItems: [
      { key: "statusApiErrors.cipSchedule" },
      { key: "statusApiErrors.dataRange" },
      { key: "statusApiErrors.outlierSelection" },
      { key: "statusApiErrors.cipShutdownIdentification" },
      { key: "statusApiErrors.cleaningEffectivenessCalculation" },
    ],
    footerKey: "statusApiErrors.afterAdjustments",
  },
};

const StatusApiErrorDialog = ({
  show,
  onClose,
  dialogType = DEFAULT_DIALOG_TYPE,
  isLifetime = false,
}) => {
  const { t } = useTranslation();

  const config =
    DIALOG_CONFIG[dialogType] || DIALOG_CONFIG[DEFAULT_DIALOG_TYPE];

  const introKey = config.introKey(isLifetime);

  const renderListItems = (items = []) =>
    items.map(({ key, subItems, subListClass }) => (
      <li className="help-list-item" key={key}>
        {t(key)}
        {Array.isArray(subItems) && subItems.length > 0 && (
          <ul className={`help-list ${subListClass || ""}`.trim()}>
            {subItems.map((subItemKey) => (
              <li className="help-list-item" key={subItemKey}>
                {t(subItemKey)}
              </li>
            ))}
          </ul>
        )}
      </li>
    ));

  if (!show) {
    return null;
  }

  return (
    <CustomModal
      show={show}
      confirmBtn={t("ValueStrings.okay")}
      width="640px"
      header={t(config.headerKey)}
      onModalClose={onClose}
    >
      <div className="help-dialog-content">
        <div className="help-section">
          <div className="help-heading">{t(introKey)}</div>
          <ul className="help-list">{renderListItems(config.listItems)}</ul>
        </div>
        {config.footerKey && (
          <div className="help-heading">{t(config.footerKey)}</div>
        )}
      </div>
    </CustomModal>
  );
};

export default StatusApiErrorDialog;
